"use client"
import useFetch from "@/app/useFetch";
import Link from "next/link";
import { usePathname } from "next/navigation";

const AwardsNav = ({ slug }) => {

    const pathname = usePathname();

    const { data: awards, loading } = useFetch(
        "/website/vigilance-awards-all",
        // { page, limit: 5 }, // pass page & limit here
        []
    );

    return (
        <>
            <div className="tabs-container ">
                <ul className="custom-tabs nav">
                    {awards?.length > 0 ? (
                        <>
                            {awards?.map((item, index) => (
                                <>
                                    <li key={index}>

                                        <Link
                                            href={`/vigilance/awards/${item.permalink}`}
                                            className={`nav-link ${slug == item?.permalink ? "active" : ""}`}

                                        >
                                            {item.name}
                                            
                                        </Link>
                                    </li>
                                </>
                            ))}

                        </>
                    ) : (
                        <>
                            <p></p>
                        </>
                    )}
                </ul>
            </div>
        </>
    )
}

export default AwardsNav
